import React from 'react';

const Media = ({block, contentState}) => {
    const entityKey = block.getEntityAt(0);
    if (!entityKey) {
        // Draft.js can transiently leave an atomic block without its entity (e.g. while backspacing
        // the block away): render nothing rather than crashing the whole page on the next paint.
        return null;
    }
    const entity = contentState.getEntity(entityKey);
    const {src} = entity.getData();
    return <img src={src} />;
};

export default Media;
